import React, {useState, useEffect, useRef} from "react";
import {useStyles} from "./styles/OddStepFiveStyle";
import {
    Box,
    Button,
    Typography,
    Tabs,
    Tab,
    TextField, Popover,
} from "@material-ui/core";
import PropTypes from 'prop-types';
import clsx from "clsx";
import {ReactComponent as TooltipTipIcon} from "../../../../../common/images/TooltipTipIcon.svg";
import {ReactComponent as TooltipClose} from "../../../../../common/images/TooltipClose.svg";
import {inject, observer} from "mobx-react";


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function OddStepFive(props) {
    const classes = useStyles();

    const {contentStore,oddStepFiveStore} = props;
    const {stepValue, dayValue} = props.contentStore;

    const anchorElRef = useRef(null);

    const handleChange = (event, newValue) => {
        oddStepFiveStore.setContentTapIndex(newValue);
        oddStepFiveStore.setIsProcessing(false);
    };

    const onSave = () => {
        oddStepFiveStore.modifyOddStepFiveContent(stepValue, dayValue, () => {
            oddStepFiveStore.getOddStepFiveContent(stepValue, dayValue, processOddStepFiveContent);
            contentStore.setReadyToSaveStep(false);
        });
    }

    const processOddStepFiveContent = (res) => {
        const isCompleted = oddStepFiveStore.isOddStepFiveCompleted(res);
        contentStore.setReadyToMoveExit(isCompleted);
    }

    useEffect(() => {
        oddStepFiveStore.getOddStepFiveContent(stepValue, dayValue, processOddStepFiveContent)
        contentStore.setOnSave(onSave);
        return ()=> {
            contentStore.setOnSave(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [anchorEl, setAnchorEl] = useState(0);
    const handleOpenPopover = (tapIndex) => {
        const textBoxId = `textBox${tapIndex}`;
        const textBoxEl = document.getElementById(textBoxId);
        if (textBoxEl) {
            anchorElRef.current = textBoxEl;
            setAnchorEl(anchorElRef.current);
            oddStepFiveStore.setPopoverState(true);
        }
    };
    const handleClosePopover = () => {
        setAnchorEl(null);
        oddStepFiveStore.setPopoverState(null);
    };
    const handleClickGenerateSentence = () => {
        oddStepFiveStore.setUpdateContent();
        oddStepFiveStore.setIsProcessing(true);
        handleOpenPopover(oddStepFiveStore.contentTapIndex);
    }

    const handleClickFinishSentence = () => {
        oddStepFiveStore.saveContent();
        oddStepFiveStore.setIsProcessing(false);
        contentStore.setReadyToSaveStep(oddStepFiveStore.isChangeContent());
    }

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    useEffect(() => {
        window.addEventListener('selectstart', handleSelectStart);

        return () => {
            window.addEventListener('selectstart', handleSelectStart);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSelectStart = (e) => {
        if (oddStepFiveStore.isProcessing) {
            if (!oddStepFiveStore.mouseDownElId || oddStepFiveStore.mouseDownElId.indexOf('char') === -1) {
                e.preventDefault();
            }
        }
    }

    useEffect(() => {
        window.addEventListener('mousedown', handleMouseDown);

        return () => {
            window.removeEventListener('mousedown', handleMouseDown);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleMouseDown = (e) => {
        if (oddStepFiveStore.isProcessing) {
            oddStepFiveStore.setMouseDownElId(e.target.id);
            const selection = document.getSelection();
            selection.removeAllRanges();
        }
    }

    useEffect(() => {
        window.addEventListener('mouseup', handleSelect);

        return () => {
            window.removeEventListener('mouseup', handleSelect);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSelect = () => {
        if (oddStepFiveStore.isProcessing) {
            const selection = document.getSelection();
            let selectedString = '';
            let selectDirection = 'right';
            if (selection.rangeCount > 0) {
                if (selection.anchorNode && selection.focusNode) {
                    const isSelectionBackward = selection.anchorNode.compareDocumentPosition(selection.focusNode) === Node.DOCUMENT_POSITION_FOLLOWING;

                    if (isSelectionBackward) {
                        selectDirection = 'right'
                    } else {
                        selectDirection = 'left'
                    }
                } else {
                    return;
                }

                for (const char of selection.toString()) {
                    if (char !== '\n') {
                        selectedString = selectedString + char;
                    }
                }

                if (selectedString.length > 0) {
                    const content = oddStepFiveStore.updateContent;
                    const sentenceContentList = content.sentenceContents;

                    const selectFirstIndex = oddStepFiveStore.selectFirstIndex;
                    let newStartIndex = selectDirection === 'right' ? selectFirstIndex : selectFirstIndex - selectedString.length;
                    let newEndIndex = newStartIndex + selectedString.length;

                    // const mainText = content.mainText;
                    // let selectedMainText = getSelectedMainText(mainText, newStartIndex, newEndIndex);

                    // if (selectedMainText !== selectedString) {
                    //     if (selectDirection === 'right') {
                    //         newStartIndex = newStartIndex;
                    //         newEndIndex = newEndIndex;
                    //     } else {
                    //         newStartIndex = newStartIndex;
                    //         newEndIndex = newEndIndex;
                    //     }
                    // }

                    const overlapSentenceContentList = sentenceContentList.filter(sentence => {
                        return (
                            (sentence.textStartIndex >= newStartIndex && sentence.textStartIndex <= newEndIndex) ||
                            (sentence.textEndIndex >= newStartIndex && sentence.textEndIndex <= newEndIndex) ||
                            (newStartIndex >= sentence.textStartIndex && newStartIndex <= sentence.textEndIndex) ||
                            (newEndIndex >= sentence.textStartIndex && newEndIndex <= sentence.textEndIndex)
                        );
                    });

                    if (overlapSentenceContentList.length > 1) {
                        const textStartIndex = Math.min(...overlapSentenceContentList.map(sentence => sentence.textStartIndex));
                        const textEndIndex = Math.max(...overlapSentenceContentList.map(sentence => sentence.textEndIndex));

                        for (const overlapSentenceContent of overlapSentenceContentList) {
                            const removeSentenceIndex = sentenceContentList.findIndex((s) => s.textStartIndex === overlapSentenceContent.textStartIndex && s.textEndIndex === overlapSentenceContent.textEndIndex);
                            oddStepFiveStore.removeSentence(sentenceContentList, removeSentenceIndex);
                        }

                        oddStepFiveStore.addSentence(sentenceContentList, textStartIndex, textEndIndex);
                    } else {
                        for (let i = 0; i < sentenceContentList.length; i++) {
                            const startIndex = sentenceContentList[i].textStartIndex;
                            const endIndex = sentenceContentList[i].textEndIndex;

                            if (startIndex <= newStartIndex && newEndIndex <= endIndex) {
                                if (startIndex === newStartIndex && newEndIndex === endIndex) {
                                    oddStepFiveStore.removeSentence(sentenceContentList, i);
                                    return;
                                } else if (startIndex <= newStartIndex && newEndIndex <= endIndex) {
                                    oddStepFiveStore.divideSentence(sentenceContentList, i, newStartIndex, newEndIndex);
                                    return;
                                }
                            } else {
                                if (isOverlap(sentenceContentList[i], {textStartIndex: newStartIndex, textEndIndex: newEndIndex})) {
                                    oddStepFiveStore.updateSentence(sentenceContentList, i, newStartIndex, newEndIndex);
                                    return;
                                }
                            }
                        }
                        oddStepFiveStore.addSentence(sentenceContentList, newStartIndex, newEndIndex);
                    }
                }
            }
        }
    }

    const isOverlap = (sentence, newSentence) => {
        return (
            (sentence.textStartIndex >= newSentence.textStartIndex && sentence.textStartIndex <= newSentence.textEndIndex) ||
            (sentence.textEndIndex >= newSentence.textStartIndex && sentence.textEndIndex <= newSentence.textEndIndex) ||
            (newSentence.textStartIndex >= sentence.textStartIndex && newSentence.textStartIndex <= sentence.textEndIndex) ||
            (newSentence.textEndIndex >= sentence.textStartIndex && newSentence.textEndIndex <= sentence.textEndIndex)
        );
    }

    // const getSelectedMainText = (mainText, newStartIndex, newEndIndex) => {
    //     let selectedMainText = '';
    //
    //     for (let i = newStartIndex; i <= newEndIndex; i++) {
    //         selectedMainText = selectedMainText + mainText[i];
    //     }
    //
    //     return selectedMainText;
    // }

    const handleSetSelectFirstIndex = (index) => {
        if (oddStepFiveStore.isProcessing) {
            const selection = document.getSelection();
            selection.removeAllRanges();

            oddStepFiveStore.setSelectFirstIndex(index);
        }
    }

    const getProcessingEl = () => {
        const content = oddStepFiveStore.updateContent;
        const sentenceContentList = content.sentenceContents;

        const sentenceIndexList = [];
        sentenceContentList.forEach(({textStartIndex, textEndIndex}) => {
            for (let i = textStartIndex; i < textEndIndex; i++) {
                sentenceIndexList.push(i);
            }
        });

        const getCharBackgroundColor = (index) => {
            return sentenceIndexList.includes(index) ? 'yellow' : 'transparent';
        };

        return (
            <TextField
                id="outlined-multiline-static"
                variant="outlined"
                multiline
                minRows={4}
                className={classes.textField}
                InputProps={{
                    inputComponent: (props) => (
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                whiteSpace: 'pre-wrap'
                            }}
                        >
                            {props.value.split('').map((char, index) => {
                                return(
                                    <span
                                        id={'char' + index}
                                        onMouseDown={() => handleSetSelectFirstIndex(index)}
                                        key={index}
                                        style={{
                                            backgroundColor: getCharBackgroundColor(index),
                                        }}
                                    >
                                        {char}
                                    </span>
                                )
                            })}
                        </div>
                    ),
                }}
                value={content.mainText}
            />
        )
    }

    const getFinishedEl = () => {
        const content = oddStepFiveStore.getSelectedContent();
        const sentenceContentList = content.sentenceContents;

        let currentIndex = Math.min(...sentenceContentList.map(sentence => sentence.textStartIndex));
        const sentenceArray = [];
        if (currentIndex !== 0) {
            sentenceArray.push({text: content.mainText.slice(0, currentIndex), isSentence: false})
        }

        sentenceContentList.forEach(({ textStartIndex, textEndIndex }) => {
            if (currentIndex !== 0) {
                sentenceArray.push({text: content.mainText.slice(currentIndex, textStartIndex), isSentence: false});
            }

            sentenceArray.push({text: content.mainText.slice(textStartIndex, textEndIndex), isSentence: true});
            currentIndex = textEndIndex;
        });
        sentenceArray.push({text: content.mainText.slice(currentIndex), isSentence: false});

        return (
            <Typography>
                {sentenceArray.map((sentence, index) => {
                    if (sentence.isSentence) {
                        return (
                            <span key={index}>{sentence.text}</span>
                        );
                    } else {
                        return (
                            <React.Fragment key={index}>{sentence.text}</React.Fragment>
                        );
                    }
                })}
            </Typography>
        )
    }

    return (
        <div className={classes.root}>
            <Box className={classes.boxWrap}>
                <Box>
                    <Box position="static" className={classes.tabBox}>
                        <Tabs value={oddStepFiveStore.contentTapIndex} onChange={handleChange} aria-label="simple tabs example">
                            <Tab label="한국어" {...a11yProps(0)} disableRipple/>
                            <Tab label="영어" {...a11yProps(1)} disableRipple/>
                            <Tab label="일본어" {...a11yProps(2)} disableRipple/>
                            <Tab label="중국어" {...a11yProps(3)} disableRipple/>
                        </Tabs>
                    </Box>
                    {Array.from({length: 4}, (_, i) => (
                        <TabPanel key={i} value={oddStepFiveStore.contentTapIndex} index={i} className={classes.textBox}>
                            {oddStepFiveStore.contentList.length > 0 &&
                                <>
                                    {oddStepFiveStore.isProcessing ?
                                        <Box id={`textBox${i}`}>
                                            {getProcessingEl()}
                                        </Box>
                                        :
                                        <Box id={`textBox${i}`} className={clsx(classes.sentenceTextBox, classes.fixTextBox)} aria-describedby={id} variant="contained" color="primary">
                                            {getFinishedEl()}
                                        </Box>
                                    }
                                </>
                            }
                        </TabPanel>
                    ))}
                    <Popover
                        id={id}
                        open={oddStepFiveStore.popoverState === null ? false : oddStepFiveStore.popoverState}
                        anchorEl={anchorEl}
                        onClose={handleClosePopover}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        className={classes.popoverTooltip}
                    >
                        <Box className={classes.tooltipTop}>
                            <TooltipTipIcon />
                        </Box>
                        <Box display={'flex'} justifyContent={'flex-end'} className={classes.tooltipBtn}>
                            <Button disableRipple onClick={handleClosePopover}>
                                <TooltipClose />
                            </Button>
                        </Box>
                        <Typography className={classes.typography}>1. 빈칸 생성을 원하는 글자를 드래그 해주세요.</Typography>
                        <Typography className={classes.typography}>2. 드래그한 영역을 다시 드래그하면 선택이 해제됩니다.</Typography>
                    </Popover>
                </Box>
                {/*빈칸생성*/}
                <Box className={classes.buttonStyle}>
                    {oddStepFiveStore.isProcessing ?
                        <Button disableRipple onClick={handleClickFinishSentence}>
                            <Typography>완료</Typography>
                        </Button>
                        :
                        <Button disableRipple onClick={handleClickGenerateSentence}>
                            {oddStepFiveStore.contentList.length > 0 &&
                                <Typography>{oddStepFiveStore.getSelectedContent().sentenceContents.length > 0 ? '수정' : '빈칸생성'}</Typography>
                            }
                        </Button>
                    }
                </Box>
            </Box>

        </div>
    );
}

export default inject('oddStepFiveStore', 'contentStore')(observer(OddStepFive))
